import React, { useEffect, useMemo, useState } from "react";
import { useChatWidgetScripts } from "../hooks/useChatWidgetScripts";
import Session from './auth/Session';

const vendorA = {
  scriptIdsToManage: ["chat-vendor-a", "chat-vendor-a-init"],
  scripts: [
    { id: "chat-vendor-a", 
      src: "https://home-c56.nice-incontact.com/inContact/ChatClient/js/embed.min.js",
      onLoad: () => {
        if (!window.icPatronChat) {
          console.error("icPatronChat not found after script load.");
          return;
        }

        window.icPatronChat.init({
          serverHost: "https://home-c56.nice-incontact.com",
          bus_no: 4604346,
          poc: "2ebbdd44-ec66-47a9-aae1-305375c84575",
          params: ["FirstName", "Last Name", "first.last@company.com", "555-555-5555"],
        });
      }, 
    },
  ],
};

const vendorB = {
  scriptIdsToManage: ["chat-vendor-b"],
  scripts: [
    { id: "chat-vendor-b", inlineText: `
          (function (g, e, n, es, ys) {
      g['_genesysJs'] = e;
      g[e] = g[e] || function () {
        (g[e].q = g[e].q || []).push(arguments)
      };
      g[e].t = 1 * new Date();
      g[e].c = es;
      ys = document.createElement('script'); ys.async = 1; ys.src = n; ys.charset = 'utf-8'; document.head.appendChild(ys);
    })(window, 'Genesys', 'https://apps.usw2.pure.cloud/genesys-bootstrap/genesys.min.js', {
      environment: 'prod-usw2',
      deploymentId: '36ad95df-1e9a-4928-8102-aba802bbed5d'
    });
      `, attrs: { "data-key": "xyz" } },
  ],
};


export default function ChatWidgetLoader() {
  const [vendor, setVendor] = useState("");


  useEffect(() => {
    const getActiveVendor = async () => {
        const token = await Session.getToken();

        try {
            const response = await fetch('api/chat-widget/decision', {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
            });

            if (!response.ok) {
                throw new Error(`Failed to load active vendor: ${response.status}`);
            }

            const data = await response.json();
            setVendor(data.activeVendor);
            return data;
        } catch (error) {
            console.log("Error receiving vendor");
            setVendor("A");
        }
    }

    getActiveVendor();
  }, [])

  useChatWidgetScripts({
    activeVendor: vendor,
    vendorA,
    vendorB,
  });

  return null;
}